export const state = {
  typeParente: undefined,
  typeParentes: [],
  communes: [],
  sousTypeParente: undefined,
  sousTypeParentes: []
}